import React, {useState} from 'react';
import {Container, Row, Col, Tabs, Tab, Table, Card, Form} from 'react-bootstrap';
import '../layout/main.scss';
import '../home/home.scss';
import './asset.scss';
import troycard from '../../images/TROYGRUN.jpg';
import sog_col from "../../images/sog_collection.png";
import cl_tookan from "../../images/cl-tookan.png";


function Asset() {
    const [open, setOpen] = useState(false);

    return (
        <div className="App">
            <div className="asset">
                <Container>
                    <h4>TROYGRUN</h4>
                    <div className="asset-content">
                        <Tabs defaultActiveKey="Asset info" id="orbs-tab" className="mb-3">
                            <Tab eventKey="Asset info" title="Asset info">
                                <div className="mn-blocks asset-info">
                                    <Row>
                                        <Col>
                                            <div className="cards cardAssetinfo">
                                                <Row>
                                                    <Col xs={12} sm={5}>
                                                        <img src={troycard} alt="Troygrun" />
                                                    </Col>
                                                    <Col xs={12} sm={7}>
                                                        <div className="card-block">
                                                            <h3 className="card-title">TROYGRUN</h3>
                                                            <h6>Spells of genesis</h6>
                                                            <hr/>
                                                            <Table hover>
                                                                <tbody>
                                                                <tr>
                                                                    <th>Title</th>
                                                                    <td>Troy Grün</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Issuance date</th>
                                                                    <td>2015-06-24</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Quantity issued</th>
                                                                    <td>1000</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Burnt</th>
                                                                    <td>800</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Locked</th>
                                                                    <td>True</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Divisible</th>
                                                                    <td>True</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Contract</th>
                                                                    <td colSpan={2}><a href="/Collection" >1JP9936VbUW8w5NqvCQ7aeKbqZxpyVPQcM</a></td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Owner</th>
                                                                    <td colSpan={2}><a href="/Collection" >1NRtcyeDsgUUuxCRERcWgnDDYDod1DPDxA</a></td>
                                                                </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </Col>
                                                </Row>


                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Tab>
                            <Tab eventKey="Transactions" title="Transactions">
                                <Table striped bordered hover>
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Asset/Contract</th>
                                        <th>Image</th>
                                        <th>Time</th>
                                        <th>Blockchain</th>
                                        <th>Collection</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>Qty</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>TROYGRUN</td>
                                        <td>(image)</td>
                                        <td>Timestamp</td>
                                        <td>Counterparty</td>
                                        <td>Spells of Genesis</td>
                                        <td>1jnewfr...sd46z</td>
                                        <td>1lfn84r...48fnh</td>
                                        <td>1</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>TROYGRUN</td>
                                        <td>(image)</td>
                                        <td>Timestamp</td>
                                        <td>Counterparty</td>
                                        <td>Spells of Genesis</td>
                                        <td>1jnewfr...sd46z</td>
                                        <td>1lfn84r...48fnh</td>
                                        <td>1</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>TROYGRUN</td>
                                        <td>(image)</td>
                                        <td>Timestamp</td>
                                        <td>Counterparty</td>
                                        <td>Spells of Genesis</td>
                                        <td>1jnewfr...sd46z</td>
                                        <td>1lfn84r...48fnh</td>
                                        <td>1</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </Tab>
                        </Tabs>
                    </div>

                </Container>
            </div>
        </div>
    );
}

export default Asset;
